import React, {Component} from 'react';
import Constants from '../constants';

class ContactProfileCard extends Component{
    
    render(){
        const contact = this.props.contact;
        const telLink = 'tel:+' + contact.phone;
        const emailLink = 'mailto:' + contact.email;
        const profileImg = Constants.reference + 'img/profiles/' + contact.image
        return(
        <div className="profile-card">
            <img src={profileImg} alt="Anthony Barrowcliffe" />
            <div className="profile-card__details">
                <p className="name"><span>{contact.name}</span></p>
                <p className="location">{contact.location}</p>
                <p><a href={telLink}>{contact.phone}</a></p>
                <p><a href={emailLink} className="btn">Email me direct</a></p>
            </div>
        </div>            
        )
    }
}

export default ContactProfileCard;


// WEBPACK FOOTER //
// ./src/js/components/ContactProfileCard.js